export default {
    appendScript: (url, id, callback) => {
        if (document.getElementById(id)) {
            return;
        }
        const s = document.createElement('script');
        s.id = id;
        s.src = url;
        s.onload = () => {
            if (callback) {
                callback();
            }
        };
        (document.getElementsByTagName('head')[0] || document.body).appendChild(s);
    },
    loadJSON: ({ url, successCallback, errorCallback }) => {
        const loadJSONfromUrl = (url, callbacks) => {
            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response.json();
                })
                .then(response => {
                    if (callbacks.success) {
                        callbacks.success(response);
                    }
                })
                .catch(error => {
                    if (callbacks.error) {
                        callbacks.error(error);
                    }
                });
        };

        loadJSONfromUrl(url, {
            success: response => {
                if (successCallback) {
                    successCallback(response);
                }
            },
            error: error => {
                if (errorCallback) {
                    errorCallback(error);
                }
            }
        });
    }
};
